export function getAuthToken() {
    const token = localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')).token : '';
    const refreshToken = localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')).refreshToken : '';
    return {token, refreshToken};
}
